document.addEventListener('DOMContentLoaded', function() {
  initVideoSliders();
});

function initVideoSliders() {
  document.querySelectorAll('.video-slider-section').forEach(function(section) {
    const sectionId = section.id;
    const sliderId = `#${sectionId} .video-slider`;
    const sliderElement = document.querySelector(sliderId);
    
    if (!sliderElement) return;
    
    // Get section settings from data attributes
    const slidesPerView = parseInt(sliderElement.closest('.video-slider-section').dataset.slidesPerView || 3);
    const autoplaySpeed = parseInt(sliderElement.closest('.video-slider-section').dataset.autoplaySpeed || 0);
    
    // Initialize Swiper
    let swiper = null;
    if (window.innerWidth < 768 && section.dataset.sliderMobile === 'true' || window.innerWidth >= 768 && section.dataset.sliderDesktop === 'true') {
      swiper = new Swiper(sliderId, {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 16,
        loop: true,
        loopAdditionalSlides: 4,
        preloadImages: true,
        speed: 800,
        preventClicks: false,
        preventClicksPropagation: false,
        navigation: {
          nextEl: `${sliderId} .swiper-button-next`,
          prevEl: `${sliderId} .swiper-button-prev`,
        },
        mousewheel: {
          forceToAxis: true,
        },
        autoplay: autoplaySpeed > 0 ? {
          delay: autoplaySpeed,
          disableOnInteraction: false,
        } : false,
        breakpoints: {
          640: {
            slidesPerView: Math.min(2.2, slidesPerView + 0.2),
            spaceBetween: 16,
          },
          768: {
            slidesPerView: Math.min(3.2, slidesPerView + 0.2),
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: slidesPerView + 0.5,
            spaceBetween: 20,
          },
        }
      });
    }
    
    // Handle video playback
    const playButtons = section.querySelectorAll('.play-button');
    const videos = section.querySelectorAll('.video-element');
    
    playButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const slide = button.closest('.swiper-slide');
        const video = slide.querySelector('.video-element');
        
        if (!slide.classList.contains('swiper-slide-active')) {
          return;
        }
        
        if (video) {
          if (video.paused) {
            // Pause all videos first
            videos.forEach(v => {
              v.pause();
              const vSlide = v.closest('.swiper-slide');
              if (vSlide) {
                vSlide.querySelector('.video-slide').classList.remove('playing');
              }
            });
            
            // Play this video
            video.play();
            slide.querySelector('.video-slide').classList.add('playing');
          } else {
            // Pause this video
            video.pause();
            slide.querySelector('.video-slide').classList.remove('playing');
          }
        }
      });
    });
    
    // Also allow clicking on the video itself to toggle play/pause
    videos.forEach(function(video) {
      video.addEventListener('click', function() {
        const slide = video.closest('.swiper-slide');
        
        if (!slide.classList.contains('swiper-slide-active')) {
          return;
        }
        
        if (video.paused) {
          // Pause all other videos first
          videos.forEach(v => {
            if (v !== video) {
              v.pause();
              const vSlide = v.closest('.swiper-slide');
              if (vSlide) {
                vSlide.querySelector('.video-slide').classList.remove('playing');
              }
            }
          });
          
          // Play this video
          video.play();
          slide.querySelector('.video-slide').classList.add('playing');
        } else {
          // Pause this video
          video.pause();
          slide.querySelector('.video-slide').classList.remove('playing');
        }
      });
    });
    if (swiper) {
      swiper.on('slideChange', function() {
        videos.forEach(video => {
          video.pause();
          const slide = video.closest('.swiper-slide');
          if (slide) {
            slide.querySelector('.video-slide').classList.remove('playing');
          }
        });
      });
    }
    
  });
}